
import BaseErrorBoundary from "./BaseErrorBoundary";
import PageNotFound from "../Main/PageNotFound";
import ErrorPage from "../Main/ErrorPage";
import AccessDeniedPage from "../Main/AccessDeniedPage";
import { isPageNotFound, isAccessDenied } from "../Utils/errorsHandling";
import Modal from "../Modals/Modal";
import withAlert from "../Alerts/withAlert";

// This is a specialized error boundary for the AuthenticationManager component, as it 
// can't use the `ModalErrorBoundary`, which would create circular dependencies between
// the loaded files, and prevent us from using inheritance to share the error handling.
//
class AuthenticationManagerErrorBoundary extends BaseErrorBoundary {
  renderErrorComponent() {
    if (isAccessDenied(this.error)) {
      return <AccessDeniedPage />;
    } else if (isPageNotFound(this.error)) {
      return <PageNotFound />;
    } else {
      return <ErrorPage />;
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    
    const errorComponent = this.renderErrorComponent();

    return (
      <Modal shouldCloseOnOverlayClick={true} onRequestClose={this.props.onClose}>
        {errorComponent}
      </Modal>
    );
  }    
};

export default withAlert(AuthenticationManagerErrorBoundary);
